<template>
  <q-table
    hide-bottom
    title="Master article data sources"
    :columns="tableColumns"
    :rows-per-page-options="[0]"
    :pagination.sync="pagination"
    :data="columnSources || []"
    :loading="!columnSources || loading"
  >
    <template #top-right>
      <q-btn size="sm" :disable="disableSave" color="green" @click="save">
        Save Data sources
      </q-btn>
    </template>

    <template #body="props">
      <q-tr :props="props">
        <q-td key="name" :props="props">
          {{ props.row.label }}
        </q-td>

        <q-td key="dataSource" :props="props">
          <q-select
            v-model="props.row.data_source"
            dense
            outlined
            :options="props.row.options"
            emit-value
            map-options
          ></q-select>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import axios from 'axios'
import * as apiTo from '../api'
import { cloneDeep } from 'lodash'

export default {
  data: () => ({
    tableColumns: [
      { name: 'name', label: 'Field Name', align: 'left' },
      {
        name: 'dataSource',
        label: 'Data source',
        align: 'left',
        style: 'width: 500px'
      }
    ],
    pagination: {
      page: 1,
      rowsPerPage: 0
    },
    loading: false,
    columnSources: null,
    originalColumnSources: null,
    dataSources: null
  }),

  computed: {
    disableSave() {
      if (!this.columnSources) return true
      return this.columnSources.every((c, index) => {
        return c.data_source === this.originalColumnSources[index].data_source
      })
    }
  },

  created() {
    this.getColumnAndDataSources()
  },

  methods: {
    getColumnAndDataSources() {
      axios.all([apiTo.getColumnSources(), apiTo.getDataSources()]).then(
        axios.spread(({ data: columnsSources }, { data: dataSources }) => {
          this.dataSources = dataSources.result
          this.setOriginalAndColumnSources(columnsSources.result)
        })
      )
    },

    getColumnSourcesWithOptions(columnsSources) {
      // add to each obj in array an `options` prop
      return columnsSources.map(col => {
        col.options = this.getColumnOptions(this.dataSources, col.column)
        return col
      })
    },

    getColumnOptions(dataSources, colName) {
      // returns dataSources which includes colName in `has_ro_article_columns`
      return dataSources
        .filter(s => s.has_ro_article_columns.includes(colName))
        .map(s => ({ label: s.name, value: s.system_name }))
    },

    getPayloadForSave() {
      return this.columnSources.map(c => ({
        id: c.id,
        column: c.column,
        data_source: c.data_source
      }))
    },

    setOriginalAndColumnSources(sources) {
      this.originalColumnSources = cloneDeep(sources)
      this.columnSources = this.getColumnSourcesWithOptions(sources)
    },

    save() {
      const payload = this.getPayloadForSave()
      this.loading = true
      apiTo
        .updateDataSources(payload)
        .then(({ data }) => this.setOriginalAndColumnSources(data.result))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
